import React, { useEffect, useState } from "react";
import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import { Spinner } from "@shopify/polaris";
import { ACCESS_TOKEN } from "../../constants";

// Every page sends the token stored in localStorage with its API calls, so it is refreshed here, before any
// protected page renders. This used to happen only on the Dashboard page, which every login landed on.
// If refreshing fails, the page still renders: the user is either redirected to log in by
// withAuthenticationRequired, or the page's own error handling takes over.
const AccessTokenGate = ({ children }) => {
  const { isLoading, isAuthenticated, getAccessTokenSilently } = useAuth0();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (isLoading) {
      return undefined;
    }
    if (!isAuthenticated) {
      setReady(true);
      return undefined;
    }
    let active = true;
    getAccessTokenSilently()
      .then((token) => localStorage.setItem(ACCESS_TOKEN, token))
      .catch((error) => console.error("Could not refresh the access token", error))
      .finally(() => {
        if (active) {
          setReady(true);
        }
      });
    return () => {
      active = false;
    };
  }, [isLoading, isAuthenticated, getAccessTokenSilently]);

  if (!ready) {
    return (
      <div className="d-flex justify-content-center aligns-Items-center h-100vh w-100">
        <Spinner accessibilityLabel="Loading" size="large" />
      </div>
    );
  }
  return children;
};

const ProtectedRoute = ({ component, ...args }) => {
  const Component = withAuthenticationRequired(component, args);
  return (
    <AccessTokenGate>
      <Component />
    </AccessTokenGate>
  );
};

export default ProtectedRoute;
